import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4b467d3c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b467d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b467d3c')) {
      api.createRecord('4b467d3c', component.options)
    } else {
      api.reload('4b467d3c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4b467d3c&scoped=true", function () {
      api.rerender('4b467d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/sales/main.vue"
export default component.exports